import { Grid, Link, TableCell, TableRow, Tooltip } from "@material-ui/core"
import React, { useEffect } from "react"
import CarTypeIcon from "../../components/CarTypeIcon"
import CustomTable from "../../components/CustomTable"
import LoadPage from "../../components/LoadPage"
import PageCustom from "../../components/PageCustom"
import PlatformRequest from "../../utils/PlatformRequest"
import MoveToInboxIcon from '@material-ui/icons/MoveToInbox'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import ActionHasNoHasPart from "../../components/ActionHasNoHasPart"

const SearchListPage = () => {
    const [searches, setSearches] = React.useState([])
    const [load, setLoad] = React.useState(false)
    const [page, setPage] = React.useState({
        currentPage: 0,
        totalItems: 0,
        totalPages: 0
    })

    useEffect(() => {
        loadSearchs(0)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const loadSearchs = (pageNumber) => {
        setLoad(true)
        PlatformRequest.getSearches(pageNumber, 10).then((response) => {
            setLoad(false)
            const { body } = response
            setSearches(body.searchList)
            setPage({
                currentPage: body.currentPage,
                totalItems: body.totalItems,
                totalPages: body.totalPages,
            })
        })
    }

    return (
        <PageCustom title="Buscas">
            <LoadPage load={load} />
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container direction="row" justify="flex-end" alignItems="center" spacing={2}>

                    <Grid item xs={12} sm={12} md={12}>
                        <CustomTable
                            title={["Tipo", "Descrição", "Data", "Ações"]}
                            pagination={true} page={page}
                            changePage={loadSearchs}
                            items={searches.map((search) => (
                                <TableRow
                                    id={`search#${search.id}`}
                                    key={search.id}
                                    hover
                                >
                                    <Tooltip title={search.carType} placement="top" arrow>
                                        <TableCell align="center">
                                            <CarTypeIcon type={search.carType} />
                                        </TableCell>
                                    </Tooltip>
                                    <TableCell
                                        component={Link}
                                        onClick={() => { window.open(`/search/${search.id}`, "_blank") }}
                                        style={{ cursor: "pointer" }}
                                        scope="row"
                                        align="left">
                                        {search.description}
                                    </TableCell>
                                    <TableCell align="left">{search.createdAt}</TableCell>
                                    <TableCell align="center">
                                        <ActionHasNoHasPart
                                            hasVariant="contained"
                                            noHasVariant="contained"
                                            search={search.id}
                                            tooltipHas="Possuo a peça"
                                            tooltipNoHas="Não possuo a peça"
                                            buttonNoHasPartText={<DeleteOutlineIcon />}
                                            buttonHasPartText={<MoveToInboxIcon />}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))
                            } />
                    </Grid>

                </Grid>

            </Grid>
        </PageCustom>
    )
}

export default SearchListPage